import { api } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export const deleteDefaultProcessStep = async ({ id }: { id: string }): Promise<void> => {
  const response = await api.defaultProcessSteps.delete.mutation({
    params: {
      id,
    },
    body: {},
  });

  if (response.status === 200) {
    return;
  }

  throw new ApiError("Failed to delete default process step", response.status, response.body);
};
